import { z } from "zod";
// Allowed Qlik tenant host pattern. Hard-coded — Qlik tenant URLs are
// predictable, and a broad allowlist is the primary SSRF defense.
const QLIK_HOST_PATTERN = /^[a-z0-9-]+\.[a-z]+\.qlikcloud\.com$/i;
export const TenantUrl = z
    .string()
    .url()
    .refine((v) => {
    try {
        const u = new URL(v);
        return u.protocol === "https:" && QLIK_HOST_PATTERN.test(u.hostname);
    }
    catch {
        return false;
    }
}, {
    message: "Must be an https URL with hostname matching <tenant>.<region>.qlikcloud.com",
});
export const ConnectionCreateBody = z.object({
    connectionName: z.string().min(1).max(120),
    tenantUrl: TenantUrl,
    apiKey: z.string().min(20).max(4096), // Qlik API keys are JWT-ish
});
export const ConnectionUpdateBody = z.object({
    connectionName: z.string().min(1).max(120).optional(),
    tenantUrl: TenantUrl.optional(),
    // Empty string OR omitted => keep existing key. Otherwise rotate.
    apiKey: z.string().min(20).max(4096).optional(),
    isActive: z.boolean().optional(),
});
export const ConnectionTestBody = z.object({
    tenantUrl: TenantUrl,
    apiKey: z.string().min(20).max(4096),
});
// Response shape for listing / single connection. NEVER includes the key.
export const ConnectionView = z.object({
    id: z.number().int(),
    connectionName: z.string(),
    tenantUrl: z.string(),
    apiKeyHint: z.string(), // last 4 chars only
    isActive: z.boolean(),
    lastTestedAt: z.string().datetime().nullable(),
    lastTestSuccess: z.boolean().nullable(),
    lastTestError: z.string().nullable(),
    createdBy: z.string().uuid(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
// Discriminated test result so the UI can render specific guidance.
export const ConnectionTestResult = z.discriminatedUnion("success", [
    z.object({
        success: z.literal(true),
        tenantInfo: z.object({
            id: z.string(),
            name: z.string(),
            email: z.string().optional(),
            tenantId: z.string().optional(),
        }),
    }),
    z.object({
        success: z.literal(false),
        errorKind: z.enum([
            "AUTH_INVALID", // 401
            "AUTH_FORBIDDEN", // 403
            "DNS_FAILURE",
            "TLS_FAILURE",
            "TIMEOUT",
            "NETWORK",
            "BAD_RESPONSE",
            "BLOCKED_HOST", // SSRF guard rejected the URL
        ]),
        message: z.string(),
    }),
]);
// Spaces inside a Qlik tenant — listed so the UI's app-filter can show a
// real "Space" dropdown instead of asking users to type a GUID.
export const SpaceView = z.object({
    id: z.string(),
    name: z.string(),
    type: z.string(), // 'personal' | 'shared' | 'managed' | 'data' | …
});
export const SpacesResponse = z.object({
    data: z.array(SpaceView),
});
//# sourceMappingURL=connection.js.map